<template>
	<div class="comp">
		<el-dialog :title="'宠物转移'" :visible.sync="dialogState" width="600px" @close="dialogClose" :close-on-click-modal="false" :top="'30vh'">
			<div style="padding:10px;">
				<div>要转移的宠物信息：</div>
			</div>
			<div style="padding:10px 0 60px 40px;">
				<span style="padding-right:30px;">{{pet.nick_name}}</span>
				<span style="padding-right:30px;">{{pet.type_name}}</span>
				<span style="padding-right:30px;">{{pet.sex}}</span>
				<span style="padding-right:30px;">{{pet.sterilization===1?'已绝育':'未绝育'}}</span>
			</div>
			<el-form ref="form">
				<el-row>
					<el-col :span="6">
						<el-form-item label="接收人:" :label-width="formLabelWidth" prop="userPhone">
							<remoteVipSelect style="width:220px"  @getCurVipItem="getCurVipItem"></remoteVipSelect>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import remoteVipSelect from "./remoteVipSelect.vue"
	export default {
		components:{remoteVipSelect},
		data() {
			return {
				dialogState:true,
				formLabelWidth: '70px',
				
				// 转移对象
				userInfo:{
					basic_info:{}
				}
			}
		},
		props:{
			userId:{
				default:''
			},
			pet:{
				default:()=>{
					return {}
				}
			}
		},
		mounted() {
			
		},
		methods: {
			dialogClose(){
				this.$emit("submit")
			},
			cancel(){
				this.$emit("submit")
			},
			getCurVipItem(item){
				this.userInfo = item;
			},
			submit(){
				this.$confirm('确定要将 '+this.pet.nick_name+' 转移到 '+this.userInfo.basic_info.nick_name+' 名下?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						memberId:this.userId,
						petId:this.pet._id,
						receiveMemberId:this.userInfo._id,
					}
					this.$http.get('/api/Pet/Transfer', params).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '转移成功',
								type: 'success'
							});
							this.$emit("submit")
						}
					})
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		
	}
</style>

